export const messages = {
  en: {
    roomCreatePayFee: {
      title: 'Room Create Fee',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      startTime: 'Start Time',
      endTime: 'End Time',
      amount: 'Amount',
      rateCycle: 'Rate Cycle',
      rate: 'Rate',
      rateStartTime: 'Rate Start Time',
      building: 'Building',
      roomState: 'Room State',
      room: 'Room',
      selectFeeType: 'Please select fee type',
      selectFeeItem: 'Please select fee item',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      inputAmount: 'Please input amount',
      inputRateCycle: 'Please input rate cycle (month)',
      inputRate: 'Please input rate',
      selectRateStartTime: 'Please select rate start time',
      selectBuilding: 'Please select building',
      selectAll: 'Select All',
      noRoom: 'No Room',
      validateError: 'Validation failed',
      noRoomSelected: 'No room selected',
      occupied: 'Occupied',
      delivered: 'Delivered',
      decorated: 'Decorated',
      vacant: 'Vacant',
      rented: 'Rented',
      sold: 'Sold'
    }
  },
  zh: {
    roomCreatePayFee: {
      title: '房屋创建费用',
      feeType: '费用类型',
      feeItem: '收费项目',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      amount: '收费金额',
      rateCycle: '递增周期',
      rate: '计费递增率',
      rateStartTime: '递增开始时间',
      building: '楼栋',
      roomState: '房屋状态',
      room: '房屋',
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      selectStartTime: '请选择计费起始时间',
      selectEndTime: '请选择计费结束时间',
      inputAmount: '请输入收费金额',
      inputRateCycle: '请输入递增周期(月份)',
      inputRate: '请输入递增率',
      selectRateStartTime: '请选择递增开始时间',
      selectBuilding: '请选择楼栋',
      selectAll: '全选',
      noRoom: '没有房屋',
      validateError: '验证失败',
      noRoomSelected: '未包含房屋',
      occupied: '已入住',
      delivered: '已交房',
      decorated: '已装修',
      vacant: '未入住',
      rented: '已出租',
      sold: '已出售'
}
  },
  'zh-TW': {
    roomCreatePayFee: {
      title: '房屋創建費用',
      feeType: '費用類型',
      feeItem: '收費項目',
      startTime: '計費起始時間',
      endTime: '計費結束時間',
      amount: '收費金額',
      rateCycle: '遞增週期',
      rate: '計費遞增率',
      rateStartTime: '遞增開始時間',
      building: '樓棟',
      roomState: '房屋狀態',
      room: '房屋',
      selectFeeType: '請選擇費用類型',
      selectFeeItem: '請選擇收費項目',
      selectStartTime: '請選擇計費起始時間',
      selectEndTime: '請選擇計費結束時間',
      inputAmount: '請輸入收費金額',
      inputRateCycle: '請輸入遞增週期(月份)',
      inputRate: '請輸入遞增率',
      selectRateStartTime: '請選擇遞增開始時間',
      selectBuilding: '請選擇樓棟',
      selectAll: '全選',
      noRoom: '沒有房屋',
      validateError: '驗證失敗',
      noRoomSelected: '未包含房屋',
      occupied: '已入住',
      delivered: '已交房',
      decorated: '已裝修',
      vacant: '未入住',
      rented: '已出租',
      sold: '已出售'
    }
  }
}